import React from "react";
import {Typography, List, ListItem, makeStyles} from "@material-ui/core";
import PropTypes from "prop-types";
import {useHtmlComponentGql} from "../../../../hooks/useHtmlComponent";
import Skeleton from "@material-ui/lab/Skeleton";

const query = `
    elementsCollection {
        items {
            ... on HowToGuideEntry {
                headline
                explanation
                sys{
                    id
                }
            }
        }
    }
`;

const useStyles = makeStyles((theme) => ({
    listItem: {
        "&:first-child": {
            paddingTop: 0
        },
        "&:last-child": {
            paddingBottom: 0
        },
    },
    listItemIcon: {
        backgroundColor: theme.palette.grey[500],
        minWidth: theme.spacing(4),
        height: theme.spacing(4),
        borderRadius: theme.spacing(2),
        marginRight: theme.spacing(2),
        alignItems: "center",
        justifyContent: "center",
        display: "flex"
    },
    listItemIconText: {
        fontWeight: 600,
        color: theme.palette.text.white,
    },
    listItemTextHeadline: {
        marginBottom: theme.spacing(1)
    }
}));

const TutorialStepNumberedList = ({componentId}) => {
    const classes = useStyles();
    const {componentData, componentDataLoading} = useHtmlComponentGql(componentId, query);
    const items = componentData?.elementsCollection?.items;

    return (
        <>
            {!componentDataLoading ? (
                <List disablePadding>
                    {items.map((item, index) => {
                        return (
                            <ListItem
                                key={item?.sys?.id}
                                className={classes.listItem}
                                alignItems={"flex-start"}
                                disableGutters
                            >
                                <div className={classes.listItemIcon}>
                                    <Typography className={classes.listItemIconText}>
                                        {index + 1}
                                    </Typography>
                                </div>
                                <div>
                                    <Typography
                                        className={classes.listItemTextHeadline}
                                        variant={"subtitle1"}
                                    >
                                        {item?.headline}
                                    </Typography>
                                    <Typography variant={"body1"}>
                                        {item?.explanation}
                                    </Typography>
                                </div>
                            </ListItem>
                        );
                    })
                    }
                </List>
            ) : (
                <Skeleton
                    variant="rect"
                    height={336}
                />
            )
            }
        </>
    );
};

TutorialStepNumberedList.propTypes = {
    componentId: PropTypes.any
};

export default TutorialStepNumberedList;
